import React from 'react';

import BatchControls from './BatchControls';

export function Batch() {
  return <BatchControls />;
}
